import React, { useEffect, useReducer } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import idx from "idx";
import {
  Container, Table, TableRow,
  TableCell, TableBody
} from "@airbus/components-react";
import { getData } from "../../utils/data.request";
import { updateDossierStats } from '../../models/dossierModel/dossierStatusActions';
import ErrorHandler from "../ErrorHandler/ErrorHandler";
import NoData from "../NoData/NoData";
import {HASH_TABLE_WITH_TOTAL} from "../../lib/constants"

import "./HashTable.scss"

const HashTable = (props) => {
  const { reportName } = useParams()
  const { sources, details } = idx(props, _ => _.content);
  const dispatch = useDispatch();
  const [state, setState] = useReducer(
    (currState, newState) => ({ ...currState, ...newState }),
    { columns: [], data: [], error: null }
  );
  useEffect(() => {
    getData(sources, reportName).then((response) => {
      const updatedData = [...response.data];
      const title = details.title;

      if (HASH_TABLE_WITH_TOTAL.includes(title)) {
        const total = updatedData.reduce((sum, item) => {
          const num = parseFloat(item.valuePercentage?.replace('%', ''));
          return sum +  num;
        }, 0);

        updatedData.push({
          riskType: title === "EI Risk Rating" ? "EI Rate" : "OI Rate",
          valuePercentage: `${total.toFixed(2)}%`
        });
      }
      response && setState({ columns: response.columns, data: updatedData });
      response && response.data && response.data.length && dispatch(updateDossierStats(reportName, response));  
    }).catch((err) => {
      setState({ error: err })
    });
  }, [sources, reportName, details.title, dispatch]);
  const { columns, data, error } = state;
  const renderTableBody = () => {
    return data.length ? data.map((row, index) => (
      <TableRow key={index}>
        {columns.map(column => (
          <TableCell data-htheader={column} key={column}>{row[column]}</TableCell>
        ))}
      </TableRow>
    )) : (
      <NoData sources={sources} columns={columns} />
    );
  }
  return (
    <Container className="hash-table-cls">
      <span className="title">{details.title}</span>
      {!error ? <Table data-htbody-column={details.title} className={HASH_TABLE_WITH_TOTAL.includes(details.title)?"risk_rate_table":"table"}>
        <TableBody className="content">
          {renderTableBody()}
        </TableBody>
      </Table> : <ErrorHandler error={error} />}
    </Container>
  )
}

export default HashTable;